!function () {
  let isProcessing = false;
  const API_URL = "https://api.awakewater.earth";

  const getCookie = n => (document.cookie.match(new RegExp("(?:^|; )" + n + "=([^;]*)")) || [])[1];

  const showLoader = el => {
    if (el.dataset.original) return;
    el.dataset.original = el.innerHTML || el.textContent;
    el.disabled = true; el.style.pointerEvents = 'none'; el.style.opacity = '0.7';
    el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin 1s linear infinite;margin-right:8px"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>Processing...';
    if (!document.getElementById('spin-css')) document.head.insertAdjacentHTML('beforeend', '<style id="spin-css">@keyframes spin{to{transform:rotate(360deg)}}</style>');
  };

  const processCheckout = () => {
    if (isProcessing) return; isProcessing = true;
    document.querySelectorAll('[type="submit"],[name="checkout"],[class*="checkout"],[id*="checkout"],a[href*="/checkout"]').forEach(showLoader);

    const cartToken = getCookie("cart"), store = Shopify?.shop || "", origin = location.origin;
    if (!cartToken || !store) return location.href = "/checkout";

    fetch("/cart.json").then(r => r.text()).then(cartData =>
      fetch(API_URL + "/api/checkout/static", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ cart_data: cartData, cartToken, originUrl: origin, storeName: store })
      })
    ).then(r => r.json()).then(json => {
      const id = json?.data, cid = window.meta?.page?.customerId;
      location.href = `${API_URL}/checkout?id=${id}${cid ? "&customer_id=" + cid : ""}`;
    }).catch(() => location.href = "/checkout");
  };

  const addHandlers = () => {
    document.querySelectorAll('form[action="/checkout"],[name="checkout"],[class*="checkout"],[id*="checkout"],a[href*="/checkout"]').forEach(el => {
      if (el.dataset.handled) return;
      el.addEventListener(el.tagName === "FORM" ? "submit" : "click", e => {
        e.preventDefault(); e.stopPropagation(); processCheckout();
      }, true);
      el.dataset.handled = 1;
    });
  };

  addHandlers();
  document.addEventListener("DOMContentLoaded", addHandlers);
  window.addEventListener("load", addHandlers);
  new MutationObserver(addHandlers).observe(document.body, { childList: true, subtree: true });
}();
